import { z } from 'zod';

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const dateField = z
  .string()
  .regex(DATE_RE, '日付を正しく入力してください。')
  .optional()
  .or(z.literal(''))
  .transform(v => (v ? v : undefined));

export const rezeptInvoiceSearchSchema = z
  .object({
    searchTermType: z.union([z.literal(1), z.literal(2)]).default(1),
    searchTreatementFrom: dateField,
    searchTreatementTo: dateField,
    searchTreatementOne: dateField,
    // 0 = すべて (all massagers); positive = specific massager id.
    massagerId: z.number().int().min(0).nullable().optional(),
    sortRadio: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]).default(1),
  })
  .superRefine((v, ctx) => {
    if (v.searchTermType === 1) {
      if (!v.searchTreatementFrom) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['searchTreatementFrom'],
          message: '日付を入力してください',
        });
      }
      if (!v.searchTreatementTo) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['searchTreatementTo'],
          message: '日付を入力してください',
        });
      }
      if (v.searchTreatementFrom && v.searchTreatementTo) {
        if (v.searchTreatementFrom > v.searchTreatementTo) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['searchTreatementTo'],
            message: '日付を正しく入力してください。',
          });
        }
      }
    }
    if (v.searchTermType === 2 && !v.searchTreatementOne) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['searchTreatementOne'],
        message: '日付を入力してください',
      });
    }
  });

export type RezeptInvoiceSearchFormValues = z.infer<typeof rezeptInvoiceSearchSchema>;
